export default {
    show: false,
    message: ''
}



// WEBPACK FOOTER //
// ./src/shared/modules/Loading/vuex/state.js